import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipments } from "@/features/equipments/hooks/useEquipments";
import { EquipmentsTransformer } from "@/features/equipments/services/equipmentTransformer";
import DashboardFilterBadge from "../DashboardFilterBadge";

const DashboardFilterEquipmentBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: equipmentOptions,
  } = useEquipments({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EquipmentsTransformer.optionsTransformer({
        showIcon: false,
      })
    }),
  });

  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.Equipment}
      options={equipmentOptions}
      filters={filters}
      setFilters={setFilters}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterEquipmentBadge;
